// ============================================================================
// AGENT ENDPOINTS
// ============================================================================
// Endpoint definitions for Agent module

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

/**
 * Base path for agent endpoints (matches AgentController route)
 */
const BASE_PATH = '/Agent';

/**
 * Agent Endpoints
 */
export const agentEndpoints = {
  /**
   * Get all agents (paginated)
   * GET /Agent
   */
  list: () => buildEndpoint(BASE_PATH),

  /**
   * Get agent by ID
   * GET /Agent/:id
   */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Get agent by code
   * GET /Agent/code/:code
   */
  getByCode: (code: string) => buildEndpointWithParams(`${BASE_PATH}/code/:code`, { code }),

  /**
   * Create new agent
   * POST /Agent
   */
  create: () => buildEndpoint(BASE_PATH),

  /**
   * Update agent
   * PUT /Agent/:id
   */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Delete agent
   * DELETE /Agent/:id
   */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Validate agent code uniqueness
   * GET /Agent/validate/code/:code?excludeId=
   */
  validateCode: (code: string) =>
    buildEndpointWithParams(`${BASE_PATH}/validate/code/:code`, { code }),
} as const;

/**
 * Export endpoints
 */
export default agentEndpoints;
